import React, { useEffect } from "react";
import {
  Text,
  Loader,
  useResponsiveWrapperContext,
  ResponsiveBox
} from "@usap/uicomponents";

export default function StaticData({ records, divHeight }) {
  const { isDesktop, size } = useResponsiveWrapperContext();

  let height = "0px";

  switch (size) {
    case "small":
      height = "400px";
      break;
    case "medium":
      height = "700px";
      break;

    default:
      height = "500px";
      break;
  }

  return (
    <ResponsiveBox
      direction="row"
      height={divHeight || height}
      pad="medium"
      round={true}
      wrap={true}
      overflow={{ vertical: "scroll" }}
      fxWidth={{ large: "700px", medium: "600px", small: "300px" }}
    >
      {records ? (
        <Text
          size="small"
          color="dark-2"
          margin={isDesktop ? { bottom: "medium" } : { bottom: "small" }}
          dangerouslySetInnerHTML={{ __html: records }}
        />
      ) : (
        <Loader />
      )}
    </ResponsiveBox>
  );
}
